import { css } from '@/styled-system/css';

export const photoCarouselPreviousButtonStyles = css.raw({
  insetInlineStart: 0,
});
